import {useState} from "../../app3";

export default function CountryDropdown() {
    const [state, patch] = useState({
        countries: [
            {
                name: 'Russian federation',
                code: '+7',
            },
            {
                name: 'USA',
                code: '+333',
            }
        ],
        isVisible: false,
    });

    setTimeout(() => {
        patch({
            countries: [
                {
                    name: 'Russian federation',
                    code: '+7',
                },
                {
                    name: 'USA',
                    code: '+333',
                },
                {
                    name: 'Russian federation',
                    code: '+7',
                },
                {
                    name: 'USA',
                    code: '+333',
                },
                {
                    name: 'Russian federation',
                    code: '+7',
                },
                {
                    name: 'USA',
                    code: '+333',
                }
            ]
        })
    })

    function handleToggleInput() {
        console.log(state.isVisible);
        patch({
            isVisible: !state.isVisible
        })
    }

    return h => {
        return h('div', {
            attrs: {
                class: 'tg-select-input',
            },
            children: [
                h('div', {
                    attrs: {
                        class: 'tg-input tg-select-input__input'
                    },
                    children: [
                        h('input', {
                            attrs: {
                                type: 'text',
                                required: 'required',
                            },
                            on: {
                                focus: handleToggleInput,
                                blur: handleToggleInput
                            }
                        }),
                        h('label', {
                            children: [
                                String('Country')
                            ]
                        })
                    ]
                }),
                h('div', {
                    attrs: {
                        class: 'tg-select-input__dropdown' + (state.isVisible ? ' is-show' : ''),
                    },
                    children: [
                        h('ul', {
                            children: state.countries.map(country => {
                                return h('li', {
                                    children: [
                                        h('span', {
                                            attrs: {
                                                class: 'flag'
                                            },
                                            children: []
                                        }),
                                        h('p', {
                                            children: [
                                                String(country.name),
                                            ]
                                        }),
                                        h('span', {
                                            attrs: {
                                                class: 'country-code'
                                            },
                                            children: [
                                                String(country.code)
                                            ]
                                        }),
                                    ]
                                })
                            })
                        })
                    ]
                })
            ]
        })
    }
}
